import { useTranslation } from "react-i18next";
import { Button, Loading, NavMenu } from "../../../../components";
import { useErrorsContext } from "../../../../contexts/ErrorsContext";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { PetitionCard } from "../../../../components/petitionCard/PetitionCard";
import { DateUtils, DisplayUtils } from "../../../../utils";
import "./PetitionDocumentation.scss";
import { getPetitionFiles } from "../../../../services/petitionServices";
import { useParametrics } from "../../../../contexts/ParametricsContext";

const PetitionDocumentation = () => {
  const { t } = useTranslation();
  const { convocation, convocationId } = useParametrics();
  const { showError } = useErrorsContext();
  const history = useHistory();
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [petition, setPetition] = useState(null);
  const [documents, setDocuments] = useState([]);

  const getDocuments = async () => {
    try {
      setLoading(true);
      const resp = await getPetitionFiles(
        convocationId,
        petition.petitionId,
        "REQUEST",
      );
      setDocuments(resp);
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!convocationId) return;
    if (!location?.state?.petition) {
      return history.replace("/petitions");
    }
    setPetition(location.state.petition);
  }, [convocationId]);

  useEffect(() => {
    if (petition) getDocuments();
  }, [petition]);

  return (
    <NavMenu>
      <div className="PetitionDocumentation">
        <div className="content">
          {loading ? (
            <div className="vh-100 d-flex justify-content-center align-items-center">
              <Loading />
            </div>
          ) : (
            <>
              <div className="w-100 d-flex justify-content-center">
                <div className="header">
                  <Button
                    icon="/misc/icons/arrow-left-blue.svg"
                    action={() => history.goBack()}
                    className="p-2 button-only-icon me-2"
                    a11y={t('Globals.return')}
                  />
                  <h1>{t("Petitions.documentation.title")}</h1>
                </div>
              </div>
              <div className="petitions">
                <PetitionCard
                  convocationTitle={convocation?.title}
                  petition={petition}
                  isButton={false}
                />
              </div>
              <div className="documents">
                {documents?.map((document) => {
                  return DisplayUtils.isMobile() ? (
                    <div key={document.fileId} className="document">
                      <img
                        className="icon-left"
                        src="/misc/icons/list-info-pink.png"
                        alt=" "
                      />
                      <div className="document-data">
                        <div className="document-data-row">
                          <div className="document-column">
                            <div className="document-column-title">
                              {t("Petitions.documentation.document")}
                            </div>
                            <div className="document-column-value">
                              {document.title}
                            </div>
                          </div>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="button-only-icon"
                        onClick={() => {
                          window.open(`/pdf-viewer/?id=${document.fileId}`);
                        }}
                      >
                        <img className="icon-right" src="/misc/icons/download.png" alt=" " />
                        <span className="sr-only">Descargar documento</span>
                      </button>
                    </div>
                  ) : (
                    <div key={document.fileId} className="document">
                      <img
                        className="icon-left"
                        src="/misc/icons/list-info-pink.png"
                        alt=" "
                      />
                      <div className="document-data">
                        <div className="document-data-row">
                          <div className="document-column">
                            <div className="document-column-title">
                              {t("Petitions.documentation.document")}
                            </div>
                            <div className="document-column-value">
                              {document.title}
                            </div>
                          </div>
                          <div className="document-column">
                            <div className="document-column-title">
                              {t("Petitions.documentation.date")}
                            </div>
                            <div className="document-column-value">
                              {DateUtils.getFormatedDate(document.updatedTime)}
                            </div>
                          </div>
                        </div>
                        <div className="document-data-row">
                          <div className="document-column">
                            <div className="document-column-title">
                              {t("Petitions.documentation.csv")}
                            </div>
                            <div className="document-column-value">
                              {document.csv}
                            </div>
                          </div>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="button-only-icon"
                        onClick={() => {
                          window.open(`/pdf-viewer/?id=${document.fileId}`);
                        }}
                      >
                        <img
                          className="icon-right"
                          src="/misc/icons/download.png"
                          alt=" "
                        />
                        <span className="sr-only">{`Descargar documento ${document.title}`}</span>
                      </button>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>
      </div>
    </NavMenu>
  );
};

export default PetitionDocumentation;
